const AlphabetKoreanIcon = /*#__PURE__*/ [
  ["path", { d: "M5 6H11.1554C12.0231 6 12.4569 6 12.7534 6.31741C13.0498 6.63483 13.0234 7.02125 12.9707 7.79408C12.7255 11.3825 10.8793 17.0157 5 19", stroke: "currentColor", strokeLinecap: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M16 3V12M16 21V12M16 12H19", stroke: "currentColor", strokeLinecap: "round", strokeWidth: "1.5", key: "1" }]
];

export { AlphabetKoreanIcon as default };
//# sourceMappingURL=AlphabetKoreanIcon.js.map
